import {UsersList} from '@flexinet/users-components';
import config from '../../config';

/**
 * The read-only users tab embedded on account, application and organization
 * pages. The list itself is the shared @flexinet/users-components view
 * (FNP-2016); this file only supplies the links. A person opens in Flexi
 * Directory, which owns user management since FNP-2017; the account link
 * stays in the console.
 *
 * `scopeId` is sent to users-api as the account scope. Each page passes its
 * `:id` route parameter, exactly as the console's own users list read it
 * before the move.
 */
export const UsersTab = ({scopeId}: { scopeId?: string }) => (
    <UsersList
        accountId={scopeId}
        getUserHref={user => `${config.platform.directory}/users/${user.id}`}
        getAccountHref={user => `/accounts/${user.accountId}`}
        homeHref='/dashboard'
    />
);
